//#region src/hooks/element-target.ts
const resolveElementTarget = (target) => target && "current" in target ? target.current : target;
//#endregion
export { resolveElementTarget };

//# sourceMappingURL=element-target.js.map